import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
	selector: 'org-context-menu',
	templateUrl: './org-context-menu.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [TranslatePipe],
	standalone: false
})
export class OrgContextMenuComponent {
	@Input() public canInvite;
	@Input() public canCreateCourse;
	@Output() public onInvite = new EventEmitter(); // eslint-disable-line @angular-eslint/no-output-on-prefix
	@Output() public onCreateCourse = new EventEmitter(); // eslint-disable-line @angular-eslint/no-output-on-prefix

	constructor () {}
}
